import { createSlice } from "@reduxjs/toolkit";

const residentialCalculatorSlice = createSlice({
  name: "residentialCalculator",
  initialState: {
    values: {},  
  },
  reducers: {
    setFormValues: (state, action) => {
      state.values = action.payload;   
    },
    clearForm: (state) => {
      state.values = {};
    },
  },
});

export const { setFormValues, clearForm } = residentialCalculatorSlice.actions;
export default residentialCalculatorSlice.reducer;
